/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Title/view.blocks to change it.
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Title({
  children,
  viewPath = "/DesignSystem/Title",
  level = "h3",
  color,
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  text,
  hyphens = "none",
  textAlign = "left",
  textOverflow = "ellipsis",
  textTransform = "none",
  whiteSpace = "nowrap",
  overflowX = "hidden",
  order = "no",
  maxWidth
  
}) {
  return (<React.Fragment
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level={level}
 color={color}
 marginTop={marginTop}
 marginBottom={marginBottom}
 marginLeft={marginLeft}
 marginRight={marginRight}
 text={text}
 hyphens={hyphens}
 textAlign={textAlign}
 textOverflow={textOverflow}
 textTransform={textTransform}
 whiteSpace={whiteSpace}
 overflowX={overflowX}
 order={order}
 maxWidth={maxWidth}
/>
{children}
</React.Fragment>)
}